import React from 'react';

import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const PVShopBreadcrumbs = ({ breadcrumbs, categorypath }) => {
    return (
        <React.Fragment>
            {breadcrumbs.length > 0 ? (
                <ol className="breadcrumb-page">
                    {breadcrumbs
                        /* this filter removes the top category breadcrumb for a subcat that acts
                        like a primary cat (New Products), so only images are 
                        displayed and not category banners */
                        .filter(
                            (bc) => !bc.linkTarget.toString().toLowerCase().includes('/newproducts')
                                 && !bc.linkTarget.toString().toLowerCase().includes('/productspecials')
                        )
                        .map((bc) => (
                            <li key={bc.sortOrder}>
                                {bc.linkText && bc.linkText.toUpperCase() === 'MY FAVORITES' ? (
                                    <div className="breadcrumb-placeholder">{bc.linkText}</div>
                                ) : (
                                    <Link
                                        to={
                                            bc.linkTarget === '/'
                                                ? '/'
                                                : categorypath + bc.linkTarget
                                        }
                                    >
                                        {bc.linkText}&nbsp;
                                    </Link>
                                )}
                            </li>
                        ))}
                </ol>
            ) : (
                ''
            )}
        </React.Fragment>
    );
};

PVShopBreadcrumbs.propTypes = {
    breadcrumbs: PropTypes.arrayOf(PropTypes.object),
    categorypath: PropTypes.string,
};

PVShopBreadcrumbs.defaultProps = {
    breadcrumbs: [],
    categorypath: '',
};

export default PVShopBreadcrumbs;
